// react
// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

import PageTitle from "../../../components/PageTitle";
// components
import Job from "./components/Job";

// selectors
import { getJobs } from "../../../selectors/jobs";

import PropTypes from "../../../lib/prop-types";

// style
import css from "./style.module.scss";

export class ViewAllJobs extends React.Component {
	static propTypes = {
		button: PropTypes.element,
		jobs: PropTypes.instanceOf(List).isRequired,
		noJobsMessage: PropTypes.string,
	};

	static defaultProps = {
		button: null,
		noJobsMessage: "No running jobs.",
	};

	state = {};

	componentDidMount() {}

	render() {
		const { jobs, button, noJobsMessage } = this.props;

		const body =
			jobs.size === 0 ? (
				<div className={css.noRunningJobs}>{noJobsMessage}</div>
			) : (
				jobs.map((job) => <Job key={job.get("_id")} job={job} />)
			);

		return (
			<>
				<PageTitle title="All Jobs" />
				<section className={css.Main}>
					<section className={css.Container}>
						<div className={css.JobListContainer}>{body}</div>

						<div className={css.NextButtonContainer}>
							<div className={css.innerGradient} />
							{button}
						</div>
					</section>
				</section>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	jobs: getJobs(state),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(() => {}),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllJobs);
